import * as THREE from 'three'

import Experience from '../Experience'
import Card from '../components/Card'

import gsap from 'gsap'

import store from '../../store'

let instance = null

export default class Cards extends THREE.Object3D {
  constructor() {
    super()

    if (instance) {
      return instance
    }
    
    instance = this    
    store.cards = this

    this.experience = new Experience()
    this.scene = this.experience.scene
    this.items = this.experience.resources.items
    this.count = 10
    
    this.rotation.z = Math.PI * -0.1

    this.scale.set(0, 0, 0)

    this.tl = null

    this.init()

    this.scene.add(this)
  }

  init() {
    this.textures = []

    for (const item in this.items) {
      if (item.includes('coin')) {
        let texture = this.items[item]
        texture.center.set(0.5, 0.5)
        texture.repeat.set(-1, 1)
        
        this.textures.push(texture)
      }
    }    

    this.cards = []

    for (let i = 0; i < this.count; i++) {
      let texture = this.textures[i]
      let card = new Card(texture)

      let a = i / this.count * Math.PI * 2
      let r = 1.4
      let x = Math.cos(a) * r
      let z = Math.sin(a) * r // -a to go on the oposite direction to align the cards correctly with the design

      card.position.set(x, 0 , z)
      card.lookAt(new THREE.Vector3())

      this.cards.push(card)
      this.add(card)
    }
  }

  update(time) {
    let t = time * -0.1

    for (let i = 0; i < this.count; i++) {
      let card = this.cards[i]

      let a = i / this.count * Math.PI * 2
      let r = 1.4
      let x = Math.cos(a + t) * r
      let y = 0
      let z = Math.sin(a + t) * r // -a to go on the oposite direction to align the cards correctly with the design

      card.position.set(x, y , z)
      card.up
        .set(0, 1, 0)
        .applyQuaternion(this.quaternion)
        
      card.lookAt(this.scene.position)
    }    
  }

  animateIn() {
    if (this.tl) {
      this.tl.kill()
      this.tl = null
    }    

    this.tl = gsap.timeline({
      defaults: {
        ease: store.sniffer.isDevice ? 'expo' : 'expo.inOut',
        duration: store.sniffer.isDevice ? 0.5 : 1,
      }
    })

    this.tl
      .to(this.scale, { 
        x: 1, 
        y: 1, 
        z: 1,
      })
      .from(this.rotation, { 
        y: -Math.PI * 1,
      }, 0)

    return this.tl
  }

  animateOut() {
    if (this.tl) {
      this.tl.kill()
      this.tl = null
    }    

    this.tl = gsap.timeline({
      onComplete: () => {
        this.scale.set(0, 0, 0)
        
        this.cards.forEach(card => card.setOpacity())
      }
    })

    for (let i = 0; i < this.count; i++) {
      let card = this.cards[i]

      this.tl.add(card.animateOut(), 0)
    }

    return this.tl
  }

  scrubOut() {
    const tl = gsap.timeline()

    for (let i = 0; i < this.count; i++) {
      let card = this.cards[i]

      tl.add(card.scrubOut(), 0)
    } 
    
    return tl
  }
 }